import { Fetch } from '../shared/general';

//#region ======== ACTIONS ========
const actions = {
  userGet     : "get_user",
  userList    : 'list_all_user',
  userCreate  : 'create_user', //create_user
  userUpdate  : 'update_user',
  userGetId   : 'get_user_byid',
  userSearch  : "search_user",
  userRequestadd  : "request_add_user",
  UserGetContact  : "get_usercontact_byid",
  userRequestaprove: "approve_add_user",
  userContactRemove : "remove_contact_user"
};
//#endregion


//#region ========== API FUNCTIONS ===========
export async function getUsers(data) {
  return Fetch({ action: actions.userGet, data: data })

}

export async function getUsersContact(data) {
  return Fetch({ action: actions.UserGetContact, data: data })

}

export async function searchUser(data) {
  return Fetch({ action: actions.userSearch, data: data })

}

export async function getUserList(data) {
  return Fetch({ action: actions.userList, data: data })
}

export async function createUser(data) {
  return Fetch({ action: actions.userCreate, data: data })
}


export async function updateUser(data) {
  return Fetch({ action: actions.userUpdate, data: data })
}

export async function requestAddUser(data) {
  return Fetch({ action: actions.userRequestadd, data: data })
}
export async function requestAproveUser(data) {
  return Fetch({ action: actions.userRequestaprove, data: data })
}
export async function requestRemoveUser(data) {
  return Fetch({ action: actions.userContactRemove, data: data })
}
export async function updateUserPassword(data) {
  return Fetch({ action: "update_user_password", data: data })
}

export async function getUserListById(data){
  return Fetch({ action: actions.userGetId, data: data })
}
//#endregion

